import { AFFILIATION_URL } from '../config/affiliationConfig';
import type { Affiliation } from '../types/affiliation';

export const fetchAffiliation = async (): Promise<Affiliation> => {
  const response = await fetch(AFFILIATION_URL);

  if (!response.ok) {
    throw new Error(`Failed to fetch affiliation: ${response.status}`);
  }

  return (await response.json()) as Affiliation;
};
